export default __webpack_public_path__ + "static/media/P900MANA4.f9113891.pdf";